import React, { Component } from 'react';
import { Row, Col, Button, Form, Accordion, Card } from 'react-bootstrap';
import { Formik } from 'formik';
import MultiSelect from 'react-multi-select-component';
import Select from "react-select";
import { formatMultipleUsersWithoutSpan } from '../../../_metronic/utils/utils';
import { DatePickerField } from './DatePickerField';
import * as constants from '../../constants';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { HouseOnboardingServices } from '../../pages/home/HouseOnboarding/HouseOnboarding.services'


const latestLeaseStatusOptions = [
    { value: "ALL", label: "Select All" },
    { label: "Pre Move-in", value: "pre-move-in" },
    { label: "Move-In in Process", value: "moveIn-in-process" },
    { label: "Moved-In", value: "moved-in" },
    { label: "Lease Extension in process", value: "leaseExtension-in-process" },
    { label: "Lease Extended", value: "leaseExtended" },
    { label: "Move-out in Process", value: "moveOut-in-process" },
    { label: "Moved-Out", value: "movedOut" },
];

const tasksOptions = [
    { label: "PMS Subscription", value: "PMS_SUBSCRIPTION" },
    { label: "Background Verification Report", value: "BACKGROUND_VERIFICATION_REPORT" },
    { label: "Move in Report", value: "MOVE_IN_REPORT" },
    { label: "Tenant Documents", value: "TENANT_DOCUMENTS" },
    { label: "Owner Documents", value: "OWNER_DOCUMENTS" },
    { label: "Lease Agreement", value: "LEASE_AGREEMENT" },
    { label: "Police Verification", value: "POLICE_VERIFICATION" },
    { label: "Home Insurance", value: "HOME_INSURANCE" }
];
export default class FilterComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ...props,
            showFilterModal: false,
            selectedTasks: [],
            latestLeaseStatusOptions: [],
            selectedCities: props.preSelectedCities || [],
            isLoading: false,
            propertyOptions: [],
            propertyQuery: '',
            propertyOffset: 0,
            propertyLimit: 50,
            availableFilters: {
                state: [
                    {
                        name: 'Open',
                        selected: props.state && props.state.includes('OPEN') ? true : false,
                        value: 'OPEN',
                        id: 0
                    },
                    {
                        name: 'Closed',
                        selected: props.state && props.state.includes('CLOSED') ? true : false,
                        value: 'CLOSED',
                        id: 1
                    },
                ],
                validityStatus: [
                    {
                        name: 'Valid',
                        selected: props.validityStatus && props.validityStatus.includes('VALID') ? true : false,
                        value: 'VALID',
                        id: 0
                    },
                    {
                        name: 'Invalid',
                        selected: props.validityStatus && props.validityStatus.includes('INVALID') ? true : false,
                        value: 'INVALID',
                        id: 1
                    },
                ],
                clearanceStatus: [
                    {
                        name: 'Paid',
                        selected: props.clearanceStatus && props.clearanceStatus.includes('PAID') ? true : false,
                        value: 'PAID',
                        id: 0
                    },
                    {
                        name: 'Pending',
                        selected: props.clearanceStatus && props.clearanceStatus.includes('PENDING') ? true : false,
                        value: 'PENDING',
                        id: 1
                    },

                ],
                direction: [
                    {
                        name: 'Credit',
                        selected: props.direction && props.direction.includes('CREDIT') ? true : false,
                        value: 'CREDIT',
                        id: 0
                    },
                    {
                        name: 'Debit',
                        selected: props.direction && props.direction.includes('DEBIT') ? true : false,
                        value: 'DEBIT',
                        id: 1
                    },
                ],
                mode: [
                    // {
                    //     name: 'NEFT',
                    //     selected: props.mode && props.mode.includes('NEFT') ? true : false,
                    //     value: 'NEFT'
                    // },
                    // {
                    //     name: 'RTGS',
                    //     selected: props.mode && props.mode.includes('RTGS') ? true : false,
                    //     value: 'RTGS'
                    // },
                    // {
                    //     name: 'IMPS',
                    //     selected: props.mode && props.mode.includes('IMPS') ? true : false,
                    //     value: 'IMPS'
                    // },
                    // {
                    //     name: 'Cheque',
                    //     selected: props.mode && props.mode.includes('CHEQUE') ? true : false,
                    //     value: 'CHEQUE'
                    // },

                    // {
                    //     name: 'Cash',
                    //     selected: props.mode && props.mode.includes('CASH') ? true : false,
                    //     value: 'CASH'
                    // },
                    {
                        name: 'DEBIT CARD',
                        selected: props.mode && props.mode.includes('DEBIT_CARD') ? true : false,
                        value: 'DEBIT_CARD'
                    },
                    {
                        name: 'CREDIT CARD',
                        selected: props.mode && props.mode.includes('CREDIT_CARD') ? true : false,
                        value: 'CREDIT_CARD'
                    },
                    {
                        name: 'NET BANKING',
                        selected: props.mode && props.mode.includes('NET_BANKING') ? true : false,
                        value: 'NET_BANKING'
                    },
                    {
                        name: 'UPI',
                        selected: props.mode && props.mode.includes('UPI') ? true : false,
                        value: 'UPI'
                    },
                ],
                transactionType: [
                    {
                        name: 'ALL',
                        selected: props.transactionType && props.transactionType.includes('ALL') ? true : false,
                        value: 0
                    },
                    {
                        name: 'REFUNDED',
                        selected: props.transactionType && props.transactionType.includes('REFUNDED') ? true : false,
                        value: 1
                    },
                    {
                        name: 'NOT REFUNDED',
                        selected: props.transactionType && props.transactionType.includes('NOT_REFUNDED') ? true : false,
                        value: 2
                    },
                ],
                propertyManagementStatus: [
                    {
                        name: 'Yes',
                        selected: props.propertyManagementStatus && props.propertyManagementStatus.includes('YES') ? true : false,
                        value: 'YES',
                        id: 0
                    },
                    {
                        name: 'No',
                        selected: props.propertyManagementStatus && props.propertyManagementStatus.includes('NO') ? true : false,
                        value: 'NO',
                        id: 1
                    },
                ],
                terminalStatusForInspection: [
                    {
                        name: 'DONE',
                        selected: props.terminalStatusForInspection && props.terminalStatusForInspection.includes('DONE') ? true : false,
                        value: 'DONE',
                        id: 0
                    },
                    {
                        name: 'CANCELLED',
                        selected: props.terminalStatusForInspection && props.terminalStatusForInspection.includes('CANCELLED') ? true : false,
                        value: 'CANCELLED',
                        id: 1
                    },
                ],
                terminalStatusForRenewal: [
                    {
                        name: "RENEWED",
                        selected: props.terminalStatusForRenewal && props.terminalStatusForRenewal.includes('RENEWED') ? true : false,
                        value: "RENEWED",
                        id: 0,

                    },
                    {
                        name: "DISCONTINUED",
                        selected: props.terminalStatusForRenewal && props.terminalStatusForRenewal.includes('DISCONTINUED') ? true : false,
                        value: "DISCONTINUED",
                        id: 1,

                    },
                    {
                        name: "MOVE OUT",
                        selected: props.terminalStatusForRenewal && props.terminalStatusForRenewal.includes('MOVE_OUT') ? true : false,
                        value: "MOVE_OUT",
                        id: 2,

                    }
                ],
                terminalStatusForOnboarding: [
                    {
                        name: "Completed",
                        selected: props.terminalStatusForOnboarding && props.terminalStatusForOnboarding.includes('COMPLETED') ? true : false,
                        value: "COMPLETED",
                        id: 0,

                    },
                    {
                        name: "Cancelled",
                        selected: props.terminalStatusForOnboarding && props.terminalStatusForOnboarding.includes('CANCELLED') ? true : false,
                        value: "CANCELLED",
                        id: 1,

                    }
                ],
                published: [
                    {
                        name: 'Yes',
                        selected: props.published && props.published.includes('YES') ? true : false,
                        value: 'YES',
                        id: 0
                    },
                    {
                        name: 'No',
                        selected: props.published && props.published.includes('NO') ? true : false,
                        value: 'NO',
                        id: 1
                    },
                ],

                beatsListingIdentifier: [],

                onboardingStatus: [
                    {
                        name: 'ON HOLD',
                        selected: props.onboardingStatus && props.onboardingStatus.includes('YES') ? true : false,
                        value: 'HOLD',
                        id: 0
                    },
                    {
                        name: 'NOT ON HOLD',
                        selected: props.onboardingStatus && props.onboardingStatus.includes('NO') ? true : false,
                        value: null,
                        id: 1
                    }
                ],
                purpose: [
                    {
                        name: 'Rent',
                        selected: props.purpose && props.purpose.includes('RENT') ? true : false,
                        value: 'RENT'
                    },
                    {
                        name: 'Security Deposit',
                        selected: props.purpose && props.purpose.includes('SECURITY_DEPOSIT') ? true : false,
                        value: 'SECURITY_DEPOSIT'
                    },
                    {
                        name: 'Token',
                        selected: props.purpose && props.purpose.includes('TOKEN') ? true : false,
                        value: 'TOKEN'
                    },
                    {
                        name: 'Invoice',
                        selected: props.purpose && props.purpose.includes('INVOICE') ? true : false,
                        value: 'INVOICE'
                    }


                ],
                status: [
                    {
                        name: 'Paid',
                        selected: props.status && props.status.includes('PAID') ? true : false,
                        value: 'PAID'
                    },
                    {
                        name: 'Pending',
                        selected: props.status && props.status.includes('PENDING') ? true : false,
                        value: 'PENDING'
                    },
                    {
                        name: 'Cancelled',
                        selected: props.status && props.status.includes('CANCELLED') ? true : false,
                        value: 'CANCELLED'
                    }
                ],
                pmsSubscriptionType: [
                    {
                        name: 'Paid',
                        selected: props.pmsSubscriptionType && props.pmsSubscriptionType.includes('Paid') ? true : false,
                        value: 'Paid',
                        id: 0
                    },
                    {
                        name: 'Free',
                        selected: props.pmsSubscriptionType && props.pmsSubscriptionType.includes('Free') ? true : false,
                        value: 'Free',
                        id: 1
                    },

                ],
                vendorStatus: [
                    {
                        name: 'Active',
                        selected: props.status && props.status.includes('Active') ? true : false,
                        value: 'Active',
                        id: 0
                    },
                    {
                        name: 'Inactive',
                        selected: props.status && props.status.includes('Inactive') ? true : false,
                        value: 'Inactive',
                        id: 1
                    }
                ],
                kycStatus: [
                    {
                        name: 'Verified',
                        selected: props.kycStatus && props.kycStatus.includes('Verified') ? true : false,
                        value: 'Verified',
                        id: 0
                    },
                    {
                        name: 'Pending',
                        selected: props.kycStatus && props.kycStatus.includes('Pending') ? true : false,
                        value: 'Pending',
                        id: 1
                    }
                ],
                rating: [
                    {
                        name: '4.5+',
                        selected: props.rating && props.rating.includes('4.5+') ? true : false,
                        value: '4.5+',
                        id: 0
                    },
                    {
                        name: '4.0+',
                        selected: props.rating && props.rating.includes('4.0+') ? true : false,
                        value: '4.0+',
                        id: 1
                    },
                    {
                        name: '3.0+',
                        selected: props.rating && props.rating.includes('3.0+') ? true : false,
                        value: '3.0+',
                        id: 2
                    }
                ],
                riskStatus: [
                    {
                        name: 'Low Risk',
                        selected: props.riskStatus && props.riskStatus.includes('NO') ? true : false,
                        value: 'NO',
                        id: 0
                    },
                    {
                        name: 'High Risk',
                        selected: props.riskStatus && props.riskStatus.includes('YES') ? true : false,
                        value: 'YES',
                        id: 1
                    },
                ],
                tokenStatus: [
                    // { name: 'Token Not Generated', value: 0 },
                    { name: 'Token Generated', value: 1 },
                    { name: 'Token Paid', value: 2 },
                    { name: 'Bank Details Added', value: 3 },
                    { name: 'Token Amount Transferred', value: 4 },
                    { name: 'Token Amount Refunded', value: 5 },
                ],

            },
            selectedCategory: props.selectedCategory || 'All Categories',
            searchQuery: props.searchQuery || ''
        };

    }

    propertyCache = {};

    async componentDidMount() {
    }

    static getDerivedStateFromProps = (props, state) => {
        let result = {};
        if (state !== props) {
            result = props;
        }
        return Object.keys(result).length > 0 ? result : null;
    }

    handleFilterButtonClick = async () => {
        this.setState(state => ({ showFilterModal: !state.showFilterModal }));
    }

    handleApplyFilterButtonClick = async () => {
        this.setState(state => ({ showFilterModal: !state.showFilterModal }));
        // create filterParams
        // make API call
    }

    handleClearFiltersButtonClick = async () => {
        //reset all filters to default
        this.setState(state => ({ showFilterModal: !state.showFilterModal }));
        //create filterParams
        // make API call
    }

    setSelected = (selectedCities) => {
        this.setState({ selectedCities });
    }
    // /**
    //  * Method to handle service request state toggle
    //  */
    // handleServiceRequestToggle = async () => {
    //     if (this.state.serviceRequestType === 'OPEN') {
    //         await this.setState({ serviceRequestType: 'CLOSED' });
    //     } else if (this.state.serviceRequestType === 'CLOSED') {
    //         await this.setState({ serviceRequestType: 'OPEN' });
    //     }
    //     this.getData();

    // }

    /**
      * Helper method to format the cities
      */
    formatResultCities = (rawCities) => {
        return rawCities.map(city => {
            return city.value
        });
    }

    /**
     * Method to handle property input change
     * @param {String} propertyQuery
     */
    handlePropertyInputChange = propertyQuery => {
        this.setState({ propertyQuery });
    };

    /**
     * Method to handle property pagination
     * @param {Object} e
     * @param {Array} shownResults
     */
    handlePropertyPagination = async (e, shownResults) => {
        const { propertyQuery } = this.state;
        const cachedPropertyQuery = this.propertyCache[propertyQuery];

        // Don't make another request if:
        // - the cached results exceed the shown results
        // - we've already fetched all possible results
        if (
            cachedPropertyQuery.options.length > shownResults ||
            cachedPropertyQuery.options.length === cachedPropertyQuery.total_count
        ) {
            return;
        }

        this.setState({ isLoading: true });
        const propertyPage = cachedPropertyQuery.propertyPage + 1;
        const { propertyLimit } = this.state;
        const propertyOffset = (propertyLimit * (propertyPage - 1));
        await this.setState({ propertyPage, propertyOffset });
        const response = await this.getAllProperties();
        const propertyOptions = cachedPropertyQuery.options.concat(response.options);
        this.propertyCache[propertyQuery] = { ...cachedPropertyQuery, propertyOptions, propertyPage, propertyOffset };
        this.setState({
            isLoading: false,
            propertyOptions,
        });
    };


    /**
     * Method to handle propertyQuery
     * @param {String} propertyQuery
     */
    handlePropertySearch = async (propertyQuery) => {
        if (this.propertyCache[propertyQuery]) {
            await this.setState({ propertyOptions: this.propertyCache[propertyQuery].options });
            return;
        }
        this.setState({ isLoading: true });
        const response = await this.getAllProperties();
        this.propertyCache[propertyQuery] = { ...response, propertyPage: 1 };
        await this.setState({
            isLoading: false,
            propertyOptions: response && response.options,
        });
    };


    /**
     * Method to get all the properties Data
     */
    getAllProperties = async () => {
        this.setState({ isLoading: true });
        const { propertyOffset, propertyLimit, propertyQuery } = this.state;
        const data = {
            searchQuery: propertyQuery,
            offset: propertyOffset,
            limit: propertyLimit,
            scope: 'ALL',
            include: ['OWNERS', 'CURRENT_TENANTS']
        }
        const result = await HouseOnboardingServices.getAllProperties(data);
        if (result && result.status === 200) {
            const total_count = result.headers['x-total-count'];
            const options = result.data.houses.map(houseData => ({
                id: houseData.id,
                property: `${houseData.formattedHouseName} | Owners: ${formatMultipleUsersWithoutSpan(houseData.owners)} | Tenants: ${formatMultipleUsersWithoutSpan(houseData.currentTenants)}`,
                propertyManagementStatus: houseData.propertyManagementStatus
            }));
            return { options, total_count };
        }
        this.setState({ isLoading: false });
    }

    handleLatestLeaseStatusChange = (selectedOptions) => {
        if (!selectedOptions) {
            this.setState({ latestLeaseStatusOptions: [] });
            return;
        }

        const isSelectAll = selectedOptions.some(
            option => option.value === "ALL"
        );

        if (isSelectAll) {
            this.setState({
                latestLeaseStatusOptions: latestLeaseStatusOptions.filter(
                    option => option.value !== "ALL"
                )
            });
        } else {
            this.setState({
                latestLeaseStatusOptions: selectedOptions
            });
        }
    };

    render() {
        const { availableFilters, requestedFilters, formattedCities, selectedCities, minimumCreatedAt,
            maximumCreatedAt, minimumClosureDatetime, maximumClosureDatetime, minimumStartDate, maximumStartDate,
            minimumEndDate, maximumEndDate, activeDate, maximumPaymentDueDate, maximumLatestNoteCreatedAt, minimumSourcePmsSubscriptionEndDate,
            maximumSourcePmsSubscriptionEndDate, minimumExpectedMoveOutDate, maximumExpectedMoveOutDate, minimumDatetime, maximumDatetime, maximumAmount, minimumAmount, minimumInvoiceDate, maximumInvoiceDate,
            minimumRentEscalationDate, maximumRentEscalationDate, minimumDueDate, maximumDueDate, maximumScheduleStartDatetime,
            propertyManagers, salesManagers, propertyManagerId, salesManagerId, propertySupervisors, assigneeId, minimumStartDatetime, maximumStartDatetime,
            maximumPreviousLeaseEndDate, maximumNoticePeriodEndDate, minimumExecutionDate, maximumExecutionDate,
            houseName, selectedHouseObject, isMyProperties, recordsPerPage, rentPaymentBillstatusData, vendorSettlementStatusData, selectedVendorSettlementStatus, selectedRentBillstatus, pmsRenewalStagesData, selectedPmsRenewalStage, selectedNewBeatsListingId, raisedBy, selectedRerentStatus, selectedRefundstatus, refundStatusData, jobTypeData, selectedJobType, moveInManagers, selectedRecordValue, onboardingStatus,
            moveInManagerId, beatsListingIdentifier, minimumOnboardingRequirementStatusMarkedAt, maximumOnboardingRequirementStatusMarkedAt, purpose, mode, transactionType, status, listingId, tokenStatus } = this.state;


        return (
            <React.Fragment>
                <Accordion defaultActiveKey="0">
                    <Card key={'test-card'}>

                        <Accordion.Toggle as={Card.Header} eventKey={'test'} className="row py-2 azuro-table-row d-flex justify-content-end align-items-center"
                        // onClick={() => { this.handleAccordionClick(req.id) }}
                        >
                            {/* Applied Filters: {requestedFilters.length} */}
                            {/* {requestedFilters && requestedFilters.length > 0 && <p className="text-muted small mb-0">
                                Applied Filters: {requestedFilters.map((item, index) => <Badge pill variant="info">{formatProperCase(item)}</Badge>)}
                            </p>} */}
                            {/* Filter Button */}
                            <Button className="mx-2" variant="link" size="sm" onClick={this.handleFilterButtonClick}>Filter</Button>
                        </Accordion.Toggle>

                        {/* Modal to show the Timeline */}
                        <Accordion.Collapse key={'test'} eventKey={'test'}>
                            <Card.Body>
                                <Row className="mb-4">
                                    <Col xs={12}>
                                        <Formik
                                            initialValues={{
                                                state: requestedFilters?.indexOf('state') >= 0 ? availableFilters.state : undefined,
                                                // mode: requestedFilters?.indexOf('mode') >= 0 ? availableFilters.mode : undefined,
                                                direction: requestedFilters?.indexOf('direction') >= 0 ? availableFilters.direction : undefined,
                                                validityStatus: requestedFilters?.indexOf('validityStatus') >= 0 ? availableFilters.validityStatus : undefined,
                                                clearanceStatus: requestedFilters?.indexOf('clearanceStatus') >= 0 ? availableFilters.clearanceStatus : undefined,
                                                terminalStatus: requestedFilters?.indexOf('terminalStatusForRenewal') >= 0 ? availableFilters.terminalStatusForRenewal : requestedFilters?.indexOf("terminalStatusForInspection") >= 0 ? availableFilters.terminalStatusForInspection : requestedFilters?.indexOf("terminalStatusForOnboarding") >= 0 ? availableFilters.terminalStatusForOnboarding : undefined,
                                                minimumCreatedAt, maximumCreatedAt, minimumClosureDatetime, maximumClosureDatetime,
                                                minimumStartDate, maximumStartDate, minimumEndDate,
                                                maximumEndDate, activeDate, maximumPaymentDueDate, maximumLatestNoteCreatedAt, minimumSourcePmsSubscriptionEndDate,
                                                maximumSourcePmsSubscriptionEndDate, minimumExpectedMoveOutDate, maximumExpectedMoveOutDate, minimumDatetime, maximumDatetime, maximumAmount, minimumAmount, listingId, minimumInvoiceDate, maximumInvoiceDate,
                                                minimumRentEscalationDate, maximumRentEscalationDate, minimumDueDate, maximumDueDate, maximumScheduleStartDatetime,
                                                minimumStartDatetime, maximumStartDatetime,
                                                propertyManagerId, salesManagerId, assigneeId, maximumPreviousLeaseEndDate, maximumNoticePeriodEndDate,
                                                minimumExecutionDate, maximumExecutionDate, houseName, beatsListingIdentifier, onboardingStatus, minimumOnboardingRequirementStatusMarkedAt, maximumOnboardingRequirementStatusMarkedAt,
                                                houseId: selectedHouseObject?.id, selectedRecordValue, moveInManagerId, selectedVendorSettlementStatus, selectedRentBillstatus, selectedPmsRenewalStage, selectedNewBeatsListingId, raisedBy, selectedRerentStatus, selectedRefundstatus, selectedJobType,
                                                pmsSubscriptionType: requestedFilters?.indexOf('pmsSubscriptionType') >= 0 ? availableFilters.pmsSubscriptionType : undefined,
                                                riskStatus: requestedFilters?.indexOf('riskStatus') >= 0 ? availableFilters.riskStatus : undefined,
                                                purpose, status, mode, transactionType,
                                                category: requestedFilters?.indexOf('category') >= 0 ? this.state.selectedCategory : 'All Categories',
                                                searchQuery: requestedFilters?.indexOf('search') >= 0 ? this.state.searchQuery : '',
                                                status: requestedFilters?.indexOf('status') >= 0 ? availableFilters.status : undefined,
                                                vendorStatus: requestedFilters?.indexOf('vendorStatus') >= 0 ? (this.state.vendorStatus || 'All') : undefined,
                                                kycStatus: requestedFilters?.indexOf('kycStatus') >= 0 ? (this.state.kycStatus || 'All') : undefined,
                                                rating: requestedFilters?.indexOf('rating') >= 0 ? (this.state.rating || 'All Ratings') : undefined,
                                                sortOrder: requestedFilters?.indexOf('sortOrder') >= 0 ? (this.state.sortOrder || '') : undefined,
                                                tokenStatus: requestedFilters?.indexOf('tokenStatus') >= 0 ? (this.state.tokenStatus || -1) : undefined,
                                            }}
                                            onSubmit={
                                                async (values, { setSubmitting, setFieldError }) => {
                                                    let result = {};
                                                    requestedFilters && requestedFilters.map((requestedFilter, index) => {
                                                        // let newRequestedFilterArray = requestedFilter;
                                                        result[requestedFilter] = []
                                                        // loop through the availableFilter of value
                                                        // Only process checkbox-type filters that exist in availableFilters
                                                        availableFilters[requestedFilter] && availableFilters[requestedFilter].map((availableFilter, index) => {
                                                            // if the selected value is true then push that to requested filter array
                                                            if (availableFilter.selected === true) {
                                                                result[requestedFilter].push(availableFilter.value)
                                                            }
                                                            return result[requestedFilter];
                                                        })
                                                        return result[requestedFilter];
                                                    });

                                                    if (this.state.selectedTasks?.length > 0 && !values.taskStatus) {
                                                        setFieldError("taskStatus", "Task Status is required");
                                                        setSubmitting(false);
                                                        return;
                                                    }
                                                    if (selectedCities) {
                                                        result['cityIds'] = this.formatResultCities(selectedCities);
                                                        result['selectedCities'] = selectedCities;
                                                    }
                                                    if (latestLeaseStatusOptions) {
                                                        result['leaseStatus'] = this.state.latestLeaseStatusOptions.map(leaseStatus => leaseStatus.value);
                                                    }
                                                    if (tasksOptions) {
                                                        result['task'] = this.state.selectedTasks.map(task => task.value);
                                                    }

                                                    const transferCriteria = ["propertyReadiness"];

                                                    if (values.transferCriteriaStatus !== "") {
                                                        result['transferCriteria'] = transferCriteria;
                                                        result['transferCriteriaStatus'] = values.transferCriteriaStatus;
                                                    }

                                                    result['minimumCreatedAt'] = values.minimumCreatedAt;
                                                    result['maximumCreatedAt'] = values.maximumCreatedAt;
                                                    result['minimumClosureDatetime'] = values.minimumClosureDatetime;
                                                    result['maximumClosureDatetime'] = values.maximumClosureDatetime;
                                                    result['minimumStartDate'] = values.minimumStartDate;
                                                    result['maximumStartDate'] = values.maximumStartDate;
                                                    result['minimumEndDate'] = values.minimumEndDate;
                                                    result['maximumEndDate'] = values.maximumEndDate;
                                                    result['activeDate'] = values.activeDate;
                                                    result['maximumPaymentDueDate'] = values.maximumPaymentDueDate;
                                                    result['maximumLatestNoteCreatedAt'] = values.maximumLatestNoteCreatedAt;
                                                    result['minimumSourcePmsSubscriptionEndDate'] = values.minimumSourcePmsSubscriptionEndDate;
                                                    result['maximumSourcePmsSubscriptionEndDate'] = values.maximumSourcePmsSubscriptionEndDate;
                                                    result['minimumExpectedMoveOutDate'] = values.minimumExpectedMoveOutDate;
                                                    result['maximumExpectedMoveOutDate'] = values.maximumExpectedMoveOutDate
                                                    result['minimumDatetime'] = values.minimumDatetime;
                                                    result['maximumDatetime'] = values.maximumDatetime;
                                                    result['maximumAmount'] = values.maximumAmount;
                                                    result['minimumAmount'] = values.minimumAmount;
                                                    result['listingId'] = values.listingId;
                                                    result['minimumInvoiceDate'] = values.minimumInvoiceDate;
                                                    result['maximumInvoiceDate'] = values.maximumInvoiceDate;
                                                    result['minimumRentEscalationDate'] = values.minimumRentEscalationDate;
                                                    result['maximumRentEscalationDate'] = values.maximumRentEscalationDate;
                                                    result['minimumDueDate'] = values.minimumDueDate;
                                                    result['maximumDueDate'] = values.maximumDueDate;
                                                    result['minimumStartDatetime'] = values.minimumStartDatetime;
                                                    result['maximumStartDatetime'] = values.maximumStartDatetime;
                                                    result['maximumScheduleStartDatetime'] = values.maximumScheduleStartDatetime;
                                                    result['propertyManagerId'] = values.propertyManagerId;
                                                    result['salesManagerId'] = values.salesManagerId;
                                                    result['assigneeId'] = values.assigneeId;
                                                    result['maximumPreviousLeaseEndDate'] = values.maximumPreviousLeaseEndDate;
                                                    result['maximumNoticePeriodEndDate'] = values.maximumNoticePeriodEndDate;
                                                    result['minimumExecutionDate'] = values.minimumExecutionDate;
                                                    result['maximumExecutionDate'] = values.maximumExecutionDate;
                                                    result['houseId'] = values.houseId;
                                                    result['houseName'] = values.houseName;
                                                    result['propertyOptions'] = values.propertyOptions;
                                                    result['limit'] = values.selectedRecordValue;
                                                    result['moveInManagerId'] = values.moveInManagerId;
                                                    result['onboardingStatus'] = values.onboardingStatus;
                                                    result['minimumOnboardingRequirementStatusMarkedAt'] = values.minimumOnboardingRequirementStatusMarkedAt;
                                                    result['maximumOnboardingRequirementStatusMarkedAt'] = values.maximumOnboardingRequirementStatusMarkedAt;
                                                    result['beatsListingIdentifier'] = values.beatsListingIdentifier;
                                                    result['purpose'] = values.purpose;
                                                    result['mode'] = values.mode;
                                                    result['transactionType'] = values.transactionType;
                                                    result['status'] = values.status;
                                                    result['vendorSettlementStatus'] = values.selectedVendorSettlementStatus;
                                                    result['rentBillstatus'] = values.selectedRentBillstatus;
                                                    result['renewalStage'] = values.selectedPmsRenewalStage;
                                                    result['reRentingStatus'] = values.selectedRerentStatus;
                                                    result['isNewbeatsNull'] = values.selectedNewBeatsListingId;
                                                    result['raisedBy'] = values.raisedBy;
                                                    result['reRentingRemarksCategory'] = values.selectedRerentingRemarksCategory;
                                                    result['refundStatus'] = values.selectedRefundstatus;
                                                    result['jobType'] = values.selectedJobType;
                                                    result['selectedJobType'] = values.selectedJobType;
                                                    result['category'] = values.category;
                                                    result['searchQuery'] = values.searchQuery;
                                                    result['vendorStatus'] = values.vendorStatus;
                                                    result['kycStatus'] = values.kycStatus;
                                                    result['rating'] = values.rating;
                                                    result['pmsCollectionMode'] = values.pmsCollectionMode;
                                                    result['taskStatus'] = values.taskStatus;
                                                    result['propertyReadinessStatus'] = values.propertyReadinessStatus;
                                                    result['expMoveinFromDate'] = values.fromDate;
                                                    result['expMoveinToDate'] = values.toDate;
                                                    result['sortOrder'] = values.sortOrder;
                                                    result['tokenStatus'] = values.tokenStatus;
                                                    this.state.filterParentCallback(result);
                                                    this.setState(state => ({ showFilterModal: !state.showFilterModal }));
                                                }
                                            }
                                        >
                                            {({ values, handleSubmit, handleChange, errors, touched, isSubmitting, setFieldValue, handleBlur }) =>
                                            (
                                                <Form onSubmit={handleSubmit}>
                                                    <Row>
                                                        {requestedFilters?.indexOf('state') >= 0 && <Col xs={12} md={2} className="mb-2">
                                                            <p className="mb-2">State</p>
                                                            {availableFilters?.state.map((item, index) =>
                                                            (
                                                                <Form.Group key={`sr-status-checkbox${index}`} controlId={`sr-status-checkbox${index}`} className="mb-2">
                                                                    <Form.Check type="checkbox">
                                                                        <Form.Check.Input type="checkbox" name="sr-status-checkbox" checked={item.selected} value={{ item }}
                                                                            onClick={() => {
                                                                                // TODO: improve the logic here
                                                                                if (item.id === index) {
                                                                                    item.selected = !item.selected
                                                                                }
                                                                                if (index !== 0) {
                                                                                    availableFilters.state[index - 1].selected = false
                                                                                } else {
                                                                                    availableFilters.state[index + 1].selected = false
                                                                                }
                                                                            }
                                                                            }
                                                                            onChange={handleChange} />
                                                                        <Form.Check.Label className="ml-3 mt-1">{item.name}</Form.Check.Label>
                                                                    </Form.Check>
                                                                </Form.Group>
                                                            )
                                                            )}
                                                        </Col>}


                                                        {availableFilters.state.some(item => item.value === "CLOSED" && item.selected) && requestedFilters?.indexOf('terminalStatusForRenewal') >= 0 && <Col xs={12} md={2} className="mb-2">
                                                            <p className="mb-2">Renewal Status </p>
                                                            {/* Terminal status For PMS Renewal Component */}
                                                            {availableFilters.terminalStatusForRenewal.map((item, index) =>
                                                            (
                                                                <Form.Group key={`terminal-status-checkbox${index}`} controlId={`terminal-status-checkbox${index}`} className="mb-2">
                                                                    <Form.Check type="checkbox">
                                                                        <Form.Check.Input type="checkbox" name="terminal-status-checkbox" checked={item.selected} value={{ item }}
                                                                            onClick={() => {
                                                                                // TODO: improve the logic here
                                                                                if (item.id === index) {
                                                                                    item.selected = !item.selected
                                                                                }
                                                                                if (index !== 0) {
                                                                                    availableFilters.terminalStatusForRenewal[index - 1].selected = false
                                                                                } else {
                                                                                    availableFilters.terminalStatusForRenewal[index + 1].selected = false
                                                                                }
                                                                            }
                                                                            }
                                                                            onChange={handleChange}
                                                                        />
                                                                        <Form.Check.Label className="ml-3 mt-1">{item.name}</Form.Check.Label>
                                                                    </Form.Check>
                                                                </Form.Group>
                                                            )
                                                            )}
                                                        </Col>}


                                                        {this.state.state && this.state.state[0] === "CLOSED" && requestedFilters?.indexOf('terminalStatusForInspection') >= 0 && <Col xs={12} md={2} className="mb-2">
                                                            <p className="mb-2">Inspection Status </p>
                                                            {/* Terminal status For PMS Renewal Component */}
                                                            {availableFilters.terminalStatusForInspection.map((item, index) =>
                                                            (
                                                                <Form.Group key={`terminal-status-checkbox${index}`} controlId={`terminal-status-checkbox${index}`} className="mb-2">
                                                                    <Form.Check type="checkbox">
                                                                        <Form.Check.Input type="checkbox" name="terminal-status-checkbox" checked={item.selected} value={{ item }}
                                                                            onClick={() => {
                                                                                // TODO: improve the logic here
                                                                                if (item.id === index) {
                                                                                    item.selected = !item.selected
                                                                                }
                                                                                if (index !== 0) {
                                                                                    availableFilters.terminalStatusForInspection[index - 1].selected = false
                                                                                } else {
                                                                                    availableFilters.terminalStatusForInspection[index + 1].selected = false
                                                                                }
                                                                            }
                                                                            }
                                                                            onChange={handleChange}
                                                                        />
                                                                        <Form.Check.Label className="ml-3 mt-1">{item.name}</Form.Check.Label>
                                                                    </Form.Check>
                                                                </Form.Group>
                                                            )
                                                            )}
                                                        </Col>}

                                                        {this.state.state && this.state.state[0] === "CLOSED" && requestedFilters?.indexOf('terminalStatusForOnboarding') >= 0 && <Col xs={12} md={2} className="mb-2">
                                                            <p className="mb-2">Onboarding Terminal Status </p>
                                                            {/* Terminal status For PMS Renewal Component */}
                                                            {availableFilters.terminalStatusForOnboarding.map((item, index) =>
                                                            (
                                                                <Form.Group key={`terminal-status-checkbox${index}`} controlId={`terminal-status-checkbox${index}`} className="mb-2">
                                                                    <Form.Check type="checkbox">
                                                                        <Form.Check.Input type="checkbox" disabled={this.state.state[0] === "OPEN"} name="terminal-status-checkbox" checked={item.selected} value={{ item }}
                                                                            onClick={() => {
                                                                                // TODO: improve the logic here
                                                                                if (item.id === index) {
                                                                                    item.selected = !item.selected
                                                                                }
                                                                                if (index !== 0) {
                                                                                    availableFilters.terminalStatusForOnboarding[index - 1].selected = false
                                                                                } else {
                                                                                    availableFilters.terminalStatusForOnboarding[index + 1].selected = false
                                                                                }
                                                                            }
                                                                            }
                                                                            onChange={handleChange}
                                                                        />
                                                                        <Form.Check.Label className="ml-3 mt-1">{item.name}</Form.Check.Label>
                                                                    </Form.Check>
                                                                </Form.Group>
                                                            )
                                                            )}
                                                        </Col>}

                                                        {'mode' in this.state && <Col xs={12} md={2}>
                                                            <Form.Group controlId="mode">
                                                                <Form.Label>Payment Mode</Form.Label>
                                                                <Form.Control as="select" name="mode" onChange={handleChange} onBlur={handleBlur} value={values.mode}>
                                                                    <option value={0}>{constants.DEFAULT_OPTION}</option>

                                                                    {availableFilters.mode.map((item, index) =>
                                                                        <option value={item.value}> {item.name}  </option>
                                                                    )}

                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'transactionType' in this.state && <Col xs={12} md={2}>
                                                            <Form.Group controlId="transactionType">
                                                                <Form.Label>Transaction Type</Form.Label>
                                                                <Form.Control as="select" name="transactionType" onChange={handleChange} onBlur={handleBlur} value={values.transactionType}>
                                                                    {availableFilters.transactionType.map((item, index) =>
                                                                        <option value={item.value}> {item.name}  </option>
                                                                    )}

                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {requestedFilters?.indexOf('category') >= 0 && this.props.serviceRequestCategories && <Col xs={12} md={2}>
                                                            <Form.Group controlId="category">
                                                                <Form.Label>Category</Form.Label>
                                                                <Form.Control as="select" name="category" onChange={handleChange} onBlur={handleBlur} value={values.category}>
                                                                    <option value="All Categories">All Categories</option>
                                                                    {this.props.serviceRequestCategories.map((category) =>
                                                                        <option key={category.id} value={category.name}> {category.name}  </option>
                                                                    )}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {requestedFilters?.indexOf('search') >= 0 && <Col xs={12} md={3}>
                                                            <Form.Group controlId="searchQuery">
                                                                <Form.Label>Search Vendor</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Search by name..."
                                                                    name="searchQuery"
                                                                    value={values.searchQuery}
                                                                    onChange={handleChange}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {requestedFilters?.indexOf('vendorStatus') >= 0 && <Col xs={12} md={2}>
                                                            <Form.Group controlId="vendorStatus">
                                                                <Form.Label>Vendor Status</Form.Label>
                                                                <Form.Control as="select" name="vendorStatus" onChange={handleChange} onBlur={handleBlur} value={values.vendorStatus}>
                                                                    <option value="All">All</option>
                                                                    {availableFilters.vendorStatus.map((item, index) =>
                                                                        <option key={item.value} value={item.value}> {item.name}  </option>
                                                                    )}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>}

                                                        {requestedFilters?.indexOf('kycStatus') >= 0 && <Col xs={12} md={2} className="mb-2">
                                                            <Form.Group controlId="kycStatus">
                                                                <Form.Label>KYC Status</Form.Label>
                                                                <Form.Control as="select" name="kycStatus" onChange={handleChange} onBlur={handleBlur} value={values.kycStatus}>
                                                                    <option value="All">All</option>
                                                                    {availableFilters.kycStatus.map((item, index) =>
                                                                        <option key={item.value} value={item.value}> {item.name}  </option>
                                                                    )}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>}

                                                        {requestedFilters?.indexOf('rating') >= 0 && <Col xs={12} md={2}>
                                                            <Form.Group controlId="rating">
                                                                <Form.Label>Rating</Form.Label>
                                                                <Form.Control as="select" name="rating" onChange={handleChange} onBlur={handleBlur} value={values.rating}>
                                                                    <option value="All Ratings">All Ratings</option>
                                                                    {availableFilters.rating.map((item, index) =>
                                                                        <option key={item.value} value={item.value}> {item.name}  </option>
                                                                    )}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>}

                                                        {requestedFilters?.indexOf('direction') >= 0 && <Col xs={12} md={2} className="mb-2">
                                                            <p className="mb-2">Payment Direction</p>
                                                            {availableFilters.direction.map((item, index) =>
                                                            (
                                                                <Form.Group key={`payment-direction-checkbox${index}`} controlId={`payment-direction-checkbox${index}`} className="mb-2">
                                                                    <Form.Check type="checkbox">
                                                                        <Form.Check.Input type="checkbox" checked={item.selected} value={{ item }}
                                                                            onClick={() => {
                                                                                // TODO: improve the logic here
                                                                                if (item.id === index) {
                                                                                    item.selected = !item.selected
                                                                                }
                                                                                if (index !== 0) {
                                                                                    availableFilters.direction[index - 1].selected = false
                                                                                } else {
                                                                                    availableFilters.direction[index + 1].selected = false
                                                                                }
                                                                            }
                                                                            }
                                                                            onChange={handleChange} />
                                                                        <Form.Check.Label className="ml-3 mt-1">{item.name}</Form.Check.Label>
                                                                    </Form.Check>
                                                                </Form.Group>

                                                            )
                                                            )}
                                                        </Col>}

                                                        {requestedFilters?.indexOf('validityStatus') >= 0 && <Col xs={12} md={2} className="mb-2">
                                                            <p className="mb-2">Validity Status</p>
                                                            {availableFilters.validityStatus.map((item, index) =>
                                                            (
                                                                <Form.Group key={`invoice-validity-checkbox${index}`} controlId={`invoice-validity-checkbox${index}`} className="mb-2">
                                                                    <Form.Check type="checkbox">
                                                                        <Form.Check.Input type="checkbox" checked={item.selected} value={{ item }}
                                                                            onClick={() => {
                                                                                // TODO: improve the logic here
                                                                                if (item.id === index) {
                                                                                    item.selected = !item.selected
                                                                                }
                                                                                if (index !== 0) {
                                                                                    availableFilters.validityStatus[index - 1].selected = false
                                                                                } else {
                                                                                    availableFilters.validityStatus[index + 1].selected = false
                                                                                }
                                                                            }
                                                                            }
                                                                            onChange={handleChange} />
                                                                        <Form.Check.Label className="ml-3 mt-1">{item.name}</Form.Check.Label>
                                                                    </Form.Check>
                                                                </Form.Group>

                                                            )
                                                            )}
                                                        </Col>}


                                                        {requestedFilters?.indexOf('clearanceStatus') >= 0 && <Col xs={12} md={2} className="mb-2">
                                                            <p className="mb-2">Clearance Status</p>
                                                            {availableFilters.clearanceStatus.map((item, index) =>
                                                            (
                                                                <Form.Group key={`invoice-clearance-status-checkbox${index}`} controlId={`invoice-clearance-status-checkbox${index}`} className="mb-2">
                                                                    <Form.Check type="checkbox">
                                                                        <Form.Check.Input type="checkbox" checked={item.selected} value={{ item }}
                                                                            onClick={() => {
                                                                                // TODO: improve the logic here
                                                                                if (item.id === index) {
                                                                                    item.selected = !item.selected
                                                                                }
                                                                                if (index !== 0) {
                                                                                    availableFilters.clearanceStatus[index - 1].selected = false
                                                                                } else {
                                                                                    availableFilters.clearanceStatus[index + 1].selected = false
                                                                                }
                                                                            }
                                                                            }
                                                                            onChange={handleChange} />
                                                                        <Form.Check.Label className="ml-3 mt-1">{item.name === 'Pending' ? 'No' : 'Yes'}</Form.Check.Label>
                                                                    </Form.Check>
                                                                </Form.Group>

                                                            )
                                                            )}
                                                        </Col>}


                                                        {(('propertyManagementStatus' in this.state && this.state.propertyManagementStatus) || isMyProperties) && <Col xs={12} md={2} className="mb-2">
                                                            <p className="mb-2">Property Under Management?</p>
                                                            {availableFilters.propertyManagementStatus.map((item, index) =>
                                                            (
                                                                <Form.Group key={`property-management-status-checkbox${index}`} controlId={`property-management-status-checkbox${index}`} className="mb-2">
                                                                    <Form.Check type="checkbox">
                                                                        <Form.Check.Input type="checkbox" checked={item.selected} value={{ item }}
                                                                            onClick={() => {
                                                                                // TODO: improve the logic here
                                                                                if (item.id === index) {
                                                                                    item.selected = !item.selected
                                                                                }
                                                                                if (index !== 0) {
                                                                                    availableFilters.propertyManagementStatus[index - 1].selected = false
                                                                                } else {
                                                                                    availableFilters.propertyManagementStatus[index + 1].selected = false
                                                                                }
                                                                            }
                                                                            }
                                                                            onChange={handleChange} />
                                                                        <Form.Check.Label className="ml-3 mt-1">{item.name}</Form.Check.Label>
                                                                    </Form.Check>
                                                                </Form.Group>

                                                            )
                                                            )}
                                                        </Col>}
                                                        {requestedFilters?.indexOf('pmsSubscriptionType') >= 0 && <Col xs={12} md={2} className="mb-2">
                                                            <p className="mb-2">Pms Subscription</p>
                                                            {availableFilters.pmsSubscriptionType.map((item, index) =>
                                                            (
                                                                <Form.Group key={`pms-subscription${index}`} controlId={`pms-subscription${index}`} className="mb-2">
                                                                    <Form.Check type="checkbox">
                                                                        <Form.Check.Input type="checkbox" checked={item.selected} value={{ item }}
                                                                            onClick={() => {
                                                                                // TODO: improve the logic here
                                                                                if (item.id === index) {
                                                                                    item.selected = !item.selected
                                                                                }
                                                                                if (index !== 0) {
                                                                                    availableFilters.pmsSubscriptionType[index - 1].selected = false
                                                                                } else {
                                                                                    availableFilters.pmsSubscriptionType[index + 1].selected = false
                                                                                }
                                                                            }
                                                                            }
                                                                            onChange={handleChange} />
                                                                        <Form.Check.Label className="ml-3 mt-1">{item.name}</Form.Check.Label>
                                                                    </Form.Check>
                                                                </Form.Group>

                                                            )
                                                            )}
                                                        </Col>}


                                                        {(('published' in this.state && this.state.published)) && <Col xs={12} md={2} className="mb-2">
                                                            <p className="mb-2">Published Status</p>
                                                            {availableFilters.published.map((item, index) =>
                                                            (
                                                                <Form.Group key={`inspection-report-published-checkbox${index}`} controlId={`inspection-report-published-checkbox${index}`} className="mb-2">
                                                                    <Form.Check type="checkbox">
                                                                        <Form.Check.Input type="checkbox" checked={item.selected} value={{ item }}
                                                                            onClick={() => {
                                                                                // TODO: improve the logic here
                                                                                if (item.id === index) {
                                                                                    item.selected = !item.selected
                                                                                }
                                                                                if (index !== 0) {
                                                                                    availableFilters.published[index - 1].selected = false
                                                                                } else {
                                                                                    availableFilters.published[index + 1].selected = false
                                                                                }
                                                                            }
                                                                            }
                                                                            onChange={handleChange} />
                                                                        <Form.Check.Label className="ml-3 mt-1">{item.name}</Form.Check.Label>
                                                                    </Form.Check>
                                                                </Form.Group>

                                                            )
                                                            )}
                                                        </Col>}

                                                        {formattedCities &&
                                                            <Col xs={12} md={2} className="mb-2">
                                                                <p className="mb-2">Cities</p>
                                                                <MultiSelect
                                                                    options={formattedCities}
                                                                    value={selectedCities}
                                                                    onChange={this.setSelected}
                                                                    labelledBy={"Select Cities"}
                                                                />
                                                            </Col>
                                                        }

                                                        {'minimumCreatedAt' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="minimumCreatedAt">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Created from'
                                                                    autoTime={true}
                                                                    dateFormat='yyyy-MM-dd'
                                                                    name='minimumCreatedAt'
                                                                    value={values.minimumCreatedAt}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumCreatedAt' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumCreatedAt">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Created till'
                                                                    autoTime={true}
                                                                    dateFormat='yyyy-MM-dd'
                                                                    name='maximumCreatedAt'
                                                                    value={values.maximumCreatedAt}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'minimumClosureDatetime' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="minimumClosureDatetime">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Closed from'
                                                                    autoTime={true}
                                                                    dateFormat='yyyy-MM-dd'
                                                                    name='minimumClosureDatetime'
                                                                    value={values.minimumClosureDatetime}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumClosureDatetime' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumClosureDatetime">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Closed till'
                                                                    autoTime={true}
                                                                    dateFormat='yyyy-MM-dd'
                                                                    name='maximumClosureDatetime'
                                                                    value={values.maximumClosureDatetime}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'minimumStartDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="minimumStartDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Started from'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='minimumStartDate'
                                                                    value={values.minimumStartDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumStartDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumStartDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Started till'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='maximumStartDate'
                                                                    value={values.maximumStartDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'minimumEndDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="minimumEndDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Ended from'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='minimumEndDate'
                                                                    value={values.minimumEndDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumEndDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumEndDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Ended till'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='maximumEndDate'
                                                                    value={values.maximumEndDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'activeDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="activeDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Active as on'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='activeDate'
                                                                    value={values.activeDate}
                                                                    onChange={setFieldValue}
                                                                    isClearable
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumPaymentDueDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumPaymentDueDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Payment Due till'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='maximumPaymentDueDate'
                                                                    value={values.maximumPaymentDueDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'minimumSourcePmsSubscriptionEndDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="minimumSourcePmsSubscriptionEndDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Subscription Ends from'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='minimumSourcePmsSubscriptionEndDate'
                                                                    value={values.minimumSourcePmsSubscriptionEndDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumSourcePmsSubscriptionEndDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumSourcePmsSubscriptionEndDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Subscription Ends by'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='maximumSourcePmsSubscriptionEndDate'
                                                                    value={values.maximumSourcePmsSubscriptionEndDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}
                                                        {'minimumExpectedMoveOutDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="minimumExpectedMoveOutDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Expected Move-out from'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='minimumExpectedMoveOutDate'
                                                                    value={values.minimumExpectedMoveOutDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumExpectedMoveOutDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumExpectedMoveOutDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Expected Move-out till'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='maximumExpectedMoveOutDate'
                                                                    value={values.maximumExpectedMoveOutDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}


                                                        {'maximumLatestNoteCreatedAt' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumLatestNoteCreatedAt">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='No Updates since'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='maximumLatestNoteCreatedAt'
                                                                    value={values.maximumLatestNoteCreatedAt}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'minimumDatetime' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="minimumDatetime">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Paid from'
                                                                    autoTime={true}
                                                                    dateFormat='yyyy-MM-dd'
                                                                    name='minimumDatetime'
                                                                    value={values.minimumDatetime}
                                                                    onChange={setFieldValue}
                                                                    maxDate={values.maximumDatetime ? new Date(values.maximumDatetime) : null}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumDatetime' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumDatetime">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Paid till'
                                                                    autoTime={true}
                                                                    dateFormat='yyyy-MM-dd'
                                                                    name='maximumDatetime'
                                                                    value={values.maximumDatetime}
                                                                    onChange={setFieldValue}
                                                                    minDate={values.minimumDatetime ? new Date(values.minimumDatetime) : null}
                                                                    maxDate={new Date()}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'minimumInvoiceDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="minimumInvoiceDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Invoice Date from'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='minimumInvoiceDate'
                                                                    value={values.minimumInvoiceDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumInvoiceDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumInvoiceDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Invoice Date till'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='maximumInvoiceDate'
                                                                    value={values.maximumInvoiceDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'minimumRentEscalationDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="minimumRentEscalationDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Earliest Escalation Date'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='minimumRentEscalationDate'
                                                                    value={values.minimumRentEscalationDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumRentEscalationDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumRentEscalationDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Latest Escaltion Date'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='maximumRentEscalationDate'
                                                                    value={values.maximumRentEscalationDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'minimumDueDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="minimumDueDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Due from'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='minimumDueDate'
                                                                    value={values.minimumDueDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumDueDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumDueDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Due by'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='maximumDueDate'
                                                                    value={values.maximumDueDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'minimumStartDatetime' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="minimumStartDatetime">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Earliest Job Start on'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    autoTime={true}
                                                                    name='minimumStartDatetime'
                                                                    value={values.minimumStartDatetime}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumStartDatetime' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumStartDatetime">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Latest Job Start on'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    autoTime={true}
                                                                    name='maximumStartDatetime'
                                                                    value={values.maximumStartDatetime}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumScheduleStartDatetime' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumScheduleStartDatetime">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Schedule Starts by'
                                                                    autoTime={true}
                                                                    dateFormat='yyyy-MM-dd'
                                                                    name='maximumScheduleStartDatetime'
                                                                    value={values.maximumScheduleStartDatetime}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumPreviousLeaseEndDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumPreviousLeaseEndDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Previous Lease Ends by'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='maximumPreviousLeaseEndDate'
                                                                    value={values.maximumPreviousLeaseEndDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumNoticePeriodEndDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumNoticePeriodEndDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Notice Period Ends by'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='maximumNoticePeriodEndDate'
                                                                    value={values.maximumNoticePeriodEndDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'minimumExecutionDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="minimumExecutionDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Execution Date from'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='minimumExecutionDate'
                                                                    value={values.minimumExecutionDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumExecutionDate' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumExecutionDate">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Execution Date till'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='maximumExecutionDate'
                                                                    value={values.maximumExecutionDate}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'listingId' in this.state && (
                                                            <Col xs={6} md={2}>
                                                                <Form.Group controlId="listingId">
                                                                    <Form.Label>Listing Id</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        name="listingId"
                                                                        value={values.listingId ?? ''}
                                                                        onChange={(e) => setFieldValue("listingId", e.target.value)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        )}

                                                        {'maximumAmount' in this.state && (
                                                            <Col xs={6} md={2}>
                                                                <Form.Group controlId="maximumAmount">
                                                                    <Form.Label>Maximum Amount</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        name="maximumAmount"
                                                                        value={values.maximumAmount}
                                                                        onChange={(e) => setFieldValue("maximumAmount", e.target.value)}
                                                                        placeholder="Enter max amount"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        )}

                                                        {'minimumAmount' in this.state && (
                                                            <Col xs={6} md={2}>
                                                                <Form.Group controlId="minimumAmount">
                                                                    <Form.Label>Minimum Amount</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        className="form-control"
                                                                        autoComplete="off"
                                                                        name="minimumAmount"
                                                                        value={values.minimumAmount}
                                                                        onChange={(e) => setFieldValue("minimumAmount", e.target.value)}
                                                                        placeholder="Enter min amount"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        )}

                                                        {'propertyManagers' in this.state && this.state.propertyManagers && <Col xs={12} md={2}>
                                                            <Form.Group controlId="propertyManagerIdSelect">
                                                                <Form.Label>Property Manager</Form.Label>
                                                                <Form.Control as="select" name="propertyManagerId" onChange={handleChange} onBlur={handleBlur} value={values.propertyManagerId}>
                                                                    <option value={0}>{constants.DEFAULT_OPTION}</option>
                                                                    <option className="text-warning" value={"null"}>PM Not Assigned</option>
                                                                    {
                                                                        propertyManagers && propertyManagers.map((pm =>
                                                                            <option key={"pm-" + pm.id} value={pm.id}> {pm.fullName}  </option>
                                                                        ))
                                                                    }
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'salesManagers' in this.state && this.state.salesManagers && <Col xs={12} md={2}>
                                                            <Form.Group controlId="salesManagerIdSelect">
                                                                <Form.Label>Sales Manager</Form.Label>
                                                                <Form.Control as="select" name="salesManagerId" onChange={handleChange} onBlur={handleBlur} value={values.salesManagerId}>
                                                                    <option value={0}>{constants.DEFAULT_OPTION}</option>
                                                                    <option className="text-warning" value={"null"}>SM Not Assigned</option>
                                                                    {
                                                                        salesManagers && salesManagers.map((sm =>
                                                                            <option key={"sm-" + sm.id} value={sm.id}> {sm.fullName}  </option>
                                                                        ))
                                                                    }
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'purpose' in this.state && <Col xs={12} md={2}>
                                                            <Form.Group controlId="purpose">
                                                                <Form.Label>Purpose</Form.Label>
                                                                <Form.Control as="select" name="purpose" onChange={handleChange} onBlur={handleBlur} value={values.purpose}>
                                                                    <option value={0}>{constants.DEFAULT_OPTION}</option>

                                                                    {availableFilters.purpose.map((item, index) =>
                                                                        <option value={item.value}> {item.name}  </option>
                                                                    )}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>}

                                                        {requestedFilters?.indexOf('tokenStatus') >= 0 && <Col xs={12} md={2}>
                                                            <Form.Group controlId="tokenStatus">
                                                                <Form.Label>Token Status</Form.Label>
                                                                <Form.Control as="select" name="tokenStatus" onChange={handleChange} onBlur={handleBlur} value={values.tokenStatus}>
                                                                    <option value={-1}>--Select--</option>
                                                                    {availableFilters.tokenStatus.map((item, index) =>
                                                                        <option key={"token-status-" + index} value={item.value}> {item.name}  </option>
                                                                    )}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>}


                                                        {'moveInManagers' in this.state && this.state.moveInManagers && <Col xs={6} md={2}>
                                                            <Form.Group controlId="moveInManagerIdSelect">
                                                                <Form.Label>Move In Manager</Form.Label>
                                                                <Form.Control as="select" name="moveInManagerId" onChange={handleChange} onBlur={handleBlur} value={values.moveInManagerId}>
                                                                    <option value={0}>{constants.DEFAULT_OPTION}</option>
                                                                    <option className="text-warning" value={"null"}>MIM Not Assigned</option>
                                                                    {
                                                                        moveInManagers && moveInManagers.map((mim =>
                                                                            <option key={"mim-" + mim.id} value={mim.id}> {mim.fullName}  </option>
                                                                        ))
                                                                    }
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'onboardingStatus' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="onboardingStatusSelect">
                                                                <Form.Label >Onboarding Status</Form.Label>
                                                                <Form.Control as="select" name="onboardingStatus" onChange={handleChange} onBlur={handleBlur} value={values.onboardingStatus}>
                                                                    <option value={0}>{constants.DEFAULT_OPTION}</option>
                                                                    <option value={'HOLD'}>ON HOLD</option>
                                                                    <option value={'null'}>NOT ON HOLD</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'minimumOnboardingRequirementStatusMarkedAt' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="minimumOnboardingRequirementStatusMarkedAt">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Onboarding Requirement Marked(Min)'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='minimumOnboardingRequirementStatusMarkedAt'
                                                                    value={values.onboardingRequirementMarkedOnMin}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'maximumOnboardingRequirementStatusMarkedAt' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="maximumOnboardingRequirementStatusMarkedAt">
                                                                <DatePickerField
                                                                    className='form-control'
                                                                    autoComplete='off'
                                                                    label='Onboarding Requirement Marked(Max)'
                                                                    dateFormat='MMMM d, yyyy'
                                                                    name='maximumOnboardingRequirementStatusMarkedAt'
                                                                    value={values.onboardingRequirementMarkedOnMax}
                                                                    onChange={setFieldValue}
                                                                />
                                                            </Form.Group>
                                                        </Col>}

                                                        {'recordsPerPage' in this.state && this.state.recordsPerPage && <Col xs={6} md={2}>
                                                            <Form.Group controlId="selectedRecordValueSelect">
                                                                <Form.Label>Records per page</Form.Label>
                                                                <Form.Control as="select" name="selectedRecordValue" onChange={handleChange} onBlur={handleBlur} value={values.selectedRecordValue} >
                                                                    {
                                                                        recordsPerPage && recordsPerPage.map((value =>
                                                                            <option key={'limit' + value} value={value}>{value}</option>
                                                                        ))
                                                                    }
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'pmsRenewalStagesData' in this.state && this.state.pmsRenewalStagesData && <Col xs={6} md={2}>
                                                            <Form.Group controlId="selectedPmsRenewalStageSelect">
                                                                <Form.Label>Renewal Stage</Form.Label>
                                                                <Form.Control as="select" name="selectedPmsRenewalStage" onChange={handleChange} onBlur={handleBlur} value={values.selectedPmsRenewalStage} >
                                                                    <option value={null}>{constants.DEFAULT_OPTION}</option>
                                                                    {
                                                                        pmsRenewalStagesData && pmsRenewalStagesData.map((value =>
                                                                            <option key={"idx" + value} value={value}>{value.replace(/_/g, ' ')}</option>
                                                                        ))
                                                                    }
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {requestedFilters?.indexOf('riskStatus') >= 0 && <Col xs={12} md={2} className="mb-2">
                                                            <p className="mb-2">Risk Status</p>
                                                            {availableFilters.riskStatus.map((item, index) =>
                                                            (
                                                                <Form.Group key={`risk-Status${index}`} controlId={`risk-Status${index}`} className="mb-2">
                                                                    <Form.Check type="checkbox">
                                                                        <Form.Check.Input type="checkbox" checked={item.selected} value={{ item }}
                                                                            onClick={() => {
                                                                                // TODO: improve the logic here
                                                                                if (item.id === index) {
                                                                                    item.selected = !item.selected
                                                                                }
                                                                                if (index !== 0) {
                                                                                    availableFilters.riskStatus[index - 1].selected = false
                                                                                } else {
                                                                                    availableFilters.riskStatus[index + 1].selected = false
                                                                                }
                                                                            }
                                                                            }
                                                                            onChange={handleChange} />
                                                                        <Form.Check.Label className="ml-3 mt-1">{item.name}</Form.Check.Label>
                                                                    </Form.Check>
                                                                </Form.Group>

                                                            )
                                                            )}
                                                        </Col>}

                                                        {requestedFilters?.indexOf('sortOrder') >= 0 && <Col xs={12} md={2} className="mb-2">
                                                            <Form.Group controlId="sortOrder">
                                                                <Form.Label>Sort Order</Form.Label>
                                                                <Form.Control as="select" name="sortOrder" onChange={handleChange} onBlur={handleBlur} value={values.sortOrder}>
                                                                    <option value="">{constants.DEFAULT_OPTION}</option>
                                                                    <option value="ASC">Oldest First</option>
                                                                    <option value="DESC">Newest First</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>}

                                                        {'rentPaymentBillstatusData' in this.state && this.state.rentPaymentBillstatusData && <Col xs={6} md={2}>
                                                            <Form.Group controlId="selectedRentBillstatusSelect">
                                                                <Form.Label>Status</Form.Label>
                                                                <Form.Control as="select" name="selectedRentBillstatus" onChange={handleChange} onBlur={handleBlur} value={values.selectedRentBillstatus} >
                                                                    <option value={null}>{constants.DEFAULT_OPTION}</option>
                                                                    {
                                                                        rentPaymentBillstatusData && rentPaymentBillstatusData.map((value =>
                                                                            <option key={"idx" + value} value={value}>{value.replace(/_/g, ' ')}</option>
                                                                        ))
                                                                    }
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'rentPaymentBillstatusData' in this.state && this.state.rentPaymentBillstatusData && <Col xs={6} md={2}>
                                                            <Form.Group controlId="selectedRentBillstatusSelect">
                                                                <Form.Label>Transfer Criteria Status</Form.Label>
                                                                <Form.Control as="select" name="transferCriteriaStatus" onChange={handleChange} onBlur={handleBlur} value={values.transferCriteriaStatus || ''} >
                                                                    <option value="">{constants.DEFAULT_OPTION}</option>
                                                                    <option value={'PENDING'}>Pending</option>
                                                                    <option value={'COMPLETED'}>Completed</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'vendorSettlementStatusData' in this.state && this.state.vendorSettlementStatusData && <Col xs={6} md={2}>
                                                            <Form.Group controlId="selectedVendorSettlementStatusSelect">
                                                                <Form.Label>Vendor Settlement Status</Form.Label>
                                                                <Form.Control as="select" name="selectedVendorSettlementStatus" onChange={handleChange} onBlur={handleBlur} value={values.selectedVendorSettlementStatus} >
                                                                    <option value={null}>{constants.DEFAULT_OPTION}</option>
                                                                    {
                                                                        vendorSettlementStatusData && vendorSettlementStatusData.map((value =>
                                                                            <option key={"vsidx" + value} value={value}>{value.replace(/_/g, ' ')}</option>
                                                                        ))
                                                                    }
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'selectedRerentStatus' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="selectedRerentStatusSelect">
                                                                <Form.Label >Rerenting Status</Form.Label>
                                                                <Form.Control as="select" name="selectedRerentStatus" onChange={handleChange} onBlur={handleBlur} value={values.selectedRerentStatus}>
                                                                    <option value={''}>{constants.DEFAULT_OPTION}</option>
                                                                    <option value={"null"}>Available</option>
                                                                    <option value={'RERENTED'}>Rerented</option>
                                                                    <option value={'HOLD'}>On-Hold</option>
                                                                    <option value={'LOST'}>Lost</option>
                                                                    <option value={'RERENTED_NOT_MERGED'}>Rerented Not Merged</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {values.selectedRerentStatus === 'LOST' && (
                                                            <Col xs={6} md={2}>
                                                                <Form.Group controlId="selectedRerentingRemarksCategorySelect">
                                                                    <Form.Label>Reason for Lost</Form.Label>
                                                                    <Form.Control
                                                                        as="select"
                                                                        name="selectedRerentingRemarksCategory"
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        value={values.selectedRerentingRemarksCategory || ''}
                                                                    >
                                                                        <option value="">{constants.DEFAULT_OPTION}</option>
                                                                        <option value="Self use by owner">Self use by owner</option>
                                                                        <option value="Property Sold Out">Property Sold Out</option>
                                                                        <option value="Owner No Longer Wants Services">Owner No Longer Wants Services</option>
                                                                        <option value="Finalized with Other Tenant/Broker">Finalized with Other Tenant/Broker</option>
                                                                        <option value="Others">Others</option>
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                        )}

                                                        {'isMyProperties' in this.state &&
                                                            <Col xs={12} md={3} className="mb-2">
                                                                <p className="mb-2">Latest Lease Status</p>
                                                                <Select
                                                                    isMulti
                                                                    options={latestLeaseStatusOptions}
                                                                    placeholder="Select"
                                                                    value={this.state.latestLeaseStatusOptions}
                                                                    onChange={this.handleLatestLeaseStatusChange}
                                                                />
                                                            </Col>
                                                        }

                                                        {'isMyProperties' in this.state &&
                                                            <Col xs={12} md={3} className="mb-2">
                                                                <p className="mb-2">Tasks</p>
                                                                <Select
                                                                    isMulti
                                                                    options={tasksOptions}
                                                                    placeholder="Select"
                                                                    value={this.state.selectedTasks}
                                                                    onChange={(selectedTasks) => {
                                                                        this.setState({ selectedTasks: selectedTasks || [] })
                                                                        if (!selectedTasks || selectedTasks.length === 0) {
                                                                            setFieldValue("taskStatus", "");
                                                                        }
                                                                    }
                                                                    }
                                                                />
                                                            </Col>
                                                        }

                                                        {this.state.isMyProperties && <Col xs={6} md={2}>
                                                            <Form.Group>
                                                                <Form.Label>Task Status</Form.Label>
                                                                <Form.Control
                                                                    as="select"
                                                                    name="taskStatus"
                                                                    placeholder='select'
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.taskStatus || ''}
                                                                    disabled={this.state.selectedTasks?.length === 0}
                                                                >
                                                                    <option value="">{constants.DEFAULT_OPTION}</option>
                                                                    <option value="PENDING">Pending</option>
                                                                    <option value="COMPLETED">Completed</option>
                                                                </Form.Control>
                                                                {errors.taskStatus && (
                                                                    <div className="text-danger">
                                                                        {errors.taskStatus}
                                                                    </div>
                                                                )}
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'isMyProperties' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group>
                                                                <Form.Label>PMS Collection Mode</Form.Label>
                                                                <Form.Control
                                                                    as="select"
                                                                    name="pmsCollectionMode"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.pmsCollectionMode || ''}
                                                                >
                                                                    <option value="">{constants.DEFAULT_OPTION}</option>
                                                                    <option value="AZURO_APP" >Azuro App</option>
                                                                    <option value="PMS_FEE_LINK">PMS Fee Link</option>
                                                                    <option value="OT_DEAL">OT deal</option>
                                                                    <option value="VIRTUAL_BANK_ACCOUNT">Virtual Bank Account</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'isMyProperties' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group>
                                                                <Form.Label>Property Readiness Status</Form.Label>
                                                                <Form.Control
                                                                    as="select"
                                                                    name="propertyReadinessStatus"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.propertyReadinessStatus || ''}
                                                                >
                                                                    <option value="">{constants.DEFAULT_OPTION}</option>
                                                                    <option value="PENDING" >Pending</option>
                                                                    <option value="COMPLETED">Completed</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'isMyProperties' in this.state && (
                                                            <>
                                                                <Col xs={6} md={2}>
                                                                    <Form.Group>
                                                                        <Form.Label>Expected Move-In Date - From</Form.Label>
                                                                        <Form.Control
                                                                            type="date"
                                                                            name="fromDate"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.fromDate || ''}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>

                                                                <Col xs={6} md={2}>
                                                                    <Form.Group>
                                                                        <Form.Label>Expected Move-In Date - To</Form.Label>
                                                                        <Form.Control
                                                                            type="date"
                                                                            name="toDate"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.toDate || ''}
                                                                            disabled={!values.fromDate}
                                                                            min={values.fromDate || ''}
                                                                            isInvalid={touched.toDate && !!errors.toDate}
                                                                        />
                                                                        <Form.Control.Feedback type="invalid">
                                                                            {errors.toDate}
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                            </>
                                                        )}

                                                        {'selectedNewBeatsListingId' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="selectedNewBeatsListingIdSelect">
                                                                <Form.Label >Listing ID status</Form.Label>
                                                                <Form.Control as="select" name="selectedNewBeatsListingId" onChange={handleChange} onBlur={handleBlur} value={values.selectedNewBeatsListingId}>
                                                                    <option value={''}>{constants.DEFAULT_OPTION}</option>
                                                                    <option value={false}>Added</option>
                                                                    <option value={true}>Not-Added</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'raisedBy' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="raisedBySelect">
                                                                <Form.Label >Raised By</Form.Label>
                                                                <Form.Control as="select" name="raisedBy" onChange={handleChange} onBlur={handleBlur} value={values.raisedBy}>
                                                                    <option value={''}>{constants.DEFAULT_OPTION}</option>
                                                                    <option value={'CUSTOMER'}>Customer</option>
                                                                    <option value={'EMPLOYEE'}>Employee</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'refundStatusData' in this.state && this.state.refundStatusData && <Col xs={6} md={2}>
                                                            <Form.Group controlId="selectedRefundstatusSelect">
                                                                <Form.Label>Status</Form.Label>
                                                                <Form.Control as="select" name="selectedRefundstatus" onChange={handleChange} onBlur={handleBlur} value={values.selectedRefundstatus} >
                                                                    <option value={null}>{constants.DEFAULT_OPTION}</option>
                                                                    {
                                                                        refundStatusData && refundStatusData.map((value =>
                                                                            <option key={"idx" + value} value={value}>{value.replace(/_/g, ' ')}</option>
                                                                        ))
                                                                    }
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'jobTypeData' in this.state && this.state.jobTypeData && <Col xs={6} md={2}>
                                                            <Form.Group controlId="selectedJobTypeSelect">
                                                                <Form.Label>Job Type</Form.Label>
                                                                <Form.Control as="select" name="selectedJobType" onChange={handleChange} onBlur={handleBlur} value={values.selectedJobType} >
                                                                    <option value={null}>{constants.DEFAULT_OPTION}</option>
                                                                    {
                                                                        jobTypeData && jobTypeData.map((value =>
                                                                            <option key={"idx" + value} value={value}>{value.replace(/_/g, ' ')}</option>
                                                                        ))
                                                                    }
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'status' in this.state && <Col xs={12} md={2}>
                                                            <Form.Group controlId="status">
                                                                <Form.Label>Status</Form.Label>
                                                                <Form.Control as="select" name="status" onChange={handleChange} onBlur={handleBlur} value={values.status}>
                                                                    <option value={0}>{constants.DEFAULT_OPTION}</option>

                                                                    {availableFilters.status.map((item, index) =>
                                                                        <option value={item.value}> {item.name}  </option>
                                                                    )}

                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'beatsListingIdentifier' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="beatsListingIdentifierSelect">
                                                                <Form.Label>Beats Listing ID</Form.Label>
                                                                <Form.Control type="text" name="beatsListingIdentifier" onChange={handleChange} onBlur={handleBlur} value={values.beatsListingIdentifier} />
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'propertySupervisors' in this.state && <Col xs={6} md={2}>
                                                            <Form.Group controlId="assigneeIdSelect">
                                                                <Form.Label>Property Supervisor</Form.Label>
                                                                <Form.Control as="select" name="assigneeId" onChange={handleChange} onBlur={handleBlur} value={values.assigneeId}>
                                                                    <option value={0}>{constants.DEFAULT_OPTION}</option>
                                                                    {
                                                                        propertySupervisors && propertySupervisors.map((ps =>
                                                                            <option key={"ps-" + ps.id} value={ps.id}> {ps.fullName}  </option>
                                                                        ))
                                                                    }
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        }

                                                        {'selectHouse' in this.state && this.state.selectHouse && <Col xs={6} className="mb-2">
                                                            <label>Search Property</label>
                                                            {selectedHouseObject && <AsyncTypeahead
                                                                name="houseId"
                                                                isLoading={this.state.isLoading}
                                                                options={this.state.propertyOptions}
                                                                query={this.state.propertyQuery}
                                                                id="async-pagination-property"
                                                                labelKey="property"
                                                                maxResults={this.state.propertyLimit - 1}
                                                                minLength={3}
                                                                onChange={async (e) => {
                                                                    const houseId = (e.length > 0) ? e[0].id : undefined;
                                                                    const houseName = (e.length > 0) ? e[0].property : undefined;
                                                                    setFieldValue('houseId', houseId);
                                                                    setFieldValue('houseName', houseName);
                                                                    setFieldValue('propertyOptions', this.state.propertyOptions)
                                                                }}
                                                                onInputChange={this.handlePropertyInputChange}
                                                                onPaginate={this.handlePropertyPagination}
                                                                onSearch={this.handlePropertySearch}
                                                                defaultSelected={[selectedHouseObject] || null}
                                                                paginate
                                                                placeholder={"Search for your property here..."}
                                                                renderMenuItemChildren={option => (
                                                                    <div key={option.id}>
                                                                        <span>{option.property}</span>
                                                                    </div>
                                                                )}
                                                                useCache={false}
                                                            />}

                                                            {!selectedHouseObject && <AsyncTypeahead
                                                                name="houseId"
                                                                isLoading={this.state.isLoading}
                                                                options={this.state.propertyOptions}
                                                                query={this.state.propertyQuery}
                                                                id="async-pagination-property"
                                                                labelKey="property"
                                                                maxResults={this.state.propertyLimit - 1}
                                                                minLength={3}
                                                                onChange={async (e) => {
                                                                    const houseId = (e.length > 0) ? e[0].id : undefined;
                                                                    const houseName = (e.length > 0) ? e[0].property : undefined;
                                                                    setFieldValue('houseId', houseId);
                                                                    setFieldValue('houseName', houseName);
                                                                    setFieldValue('propertyOptions', this.state.propertyOptions)
                                                                }}
                                                                onInputChange={this.handlePropertyInputChange}
                                                                onPaginate={this.handlePropertyPagination}
                                                                onSearch={this.handlePropertySearch}
                                                                paginate
                                                                placeholder={"Search for your property here..."}
                                                                renderMenuItemChildren={option => (
                                                                    <div key={option.id}>
                                                                        <span>{option.property}</span>
                                                                    </div>
                                                                )}
                                                                useCache={false}
                                                            />}
                                                        </Col>}
                                                    </Row>
                                                    <Row>
                                                        <Col xs={12} className="text-right">
                                                            {/* <Button variant="secondary" className="mr-2" onClick={this.handleClearFiltersButtonClick}>
                                                            Clear All
                                                        </Button> */}
                                                            <Button type="submit" variant="primary" disabled={isSubmitting}>
                                                                Apply
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </React.Fragment>
        );
    }

}
